import * as q from "@rei/breakpoint-detector";
import { getUser as Q } from "@rei/session";
import M from "@rei/server-prop";
import P from "js-cookie";
const c = (e) => {
  const { config: t, eventLog: n, errors: i } = window.metrics, { eventType: o = "", level: r, message: s } = e, a = () => ["view", "link", "event", "click"].includes(o);
  return r === "error" && i.push(e), a() && n.push(e), t.logToConsole && s ? console.log(`[Analytics ${r}] ${s}`) : t.logToConsole ? console.log(`[Analytics ${o}]`, e) : !1;
}, B = (e, t) => {
  const n = new Promise((i, o) => {
    setTimeout(() => o(new Error(`Timed out after ${e} ms.`)), e);
  });
  return Promise.race([t, n]);
}, K = () => window.navigator.globalPrivacyControl ? "true" : "false";
function G() {
  const e = [], t = document.cookie ? document.cookie.split("; ") : [];
  let n = [];
  return t.length && (n = t.filter((i) => i.match(/^akaas_(.+)=/))), n.forEach((i) => {
    var u, p, f;
    const o = i.split("="), r = o[0].split("akaas_")[1], s = (u = o.slice(1)) == null ? void 0 : u.join("="), a = (p = s == null ? void 0 : s.split("rn=")) != null ? p : [];
    let l = "";
    (f = a[1]) != null && f.length && (l = decodeURIComponent(a[1]), e.push(`${r}:${l}`));
  }), e;
}
function W() {
  const e = [], t = document.querySelector("#ew-analytics");
  try {
    const { ewExperiences: n } = t ? JSON.parse(t.innerHTML) : [];
    n != null && n.length && n.forEach((i) => {
      e.push(`${i.ewExperience.replace(":", " ")}:${i.ewVariant.replace(":", " ")}`);
    });
  } catch (n) {
    return c({
      level: "warn",
      message: `Could not get Edgeworker experiences: ${n}`
    }), [];
  }
  return e;
}
function H() {
  const e = W(), t = G(), n = [...e, ...t];
  return n.length ? {
    akamaiExperiences: n.join(",")
  } : {};
}
const Y = ["siteId", "templateType"], J = ["linkName", "pageName"], A = ":", N = "_", X = {
  view: Y,
  link: J
}, T = {
  env: "qa",
  profile: "main",
  noview: !0,
  logToConsole: !0,
  autoClickListeners: !1
}, _ = {
  www: "prod",
  localhost: "LocalDev"
}, C = {
  blog: "blog",
  used: "microsites"
}, Z = /;+$/, $ = (e) => {
  const t = /\||;/g;
  return typeof e == "string" && (e.includes("|") || e.includes(";")) ? e.replace(t, " ") : e;
}, ee = (e, t) => {
  let n = "";
  return e.forEach((i, o, r) => {
    const a = o === r.length - 1 ? ";" : "|";
    if (typeof i == "string")
      t === "evars" && c({
        level: "warn",
        message: `evar '${i}' must have a value. Ex: ${i}=value`
      }), n += `${i}${a}`;
    else {
      const [[l, u]] = Object.entries(i), p = $(l), f = $(u);
      n += `${p}=${f}${a}`;
    }
  }), n;
}, te = (e) => {
  if (!e.productStyle)
    return c({
      level: "warn",
      message: "`productStyle` is a required field"
    });
  const {
    productStyle: t,
    productQty: n,
    productPrice: i,
    events: o,
    evars: r
  } = e, s = /* @__PURE__ */ new Map();
  s.set("events", o), s.set("evars", r);
  const a = n ? n + ";" : ";", l = i ? i + ";" : ";";
  let u = `;${t};${a}${l}`;
  return (o || r) && s.forEach((p, f) => {
    if (p === void 0) {
      u += ";";
      return;
    }
    const w = ee(
      p,
      f
    );
    u += `${w}`;
  }), u = u.replace(Z, ""), u;
}, ne = (e) => typeof e == "string" ? e : Array.isArray(e) ? e.map((n) => te(n)).join(",") : "", ie = (e) => typeof e != "string" ? null : e.split(",").map((r) => r.split(";").filter((s) => s !== "")).map((r) => r[0]).join(","), oe = () => {
  const t = localStorage.getItem("sscid");
  return t || crypto.randomUUID();
}, se = (e) => {
  const t = document.cookie.split("; ").find((n) => n.startsWith(`${e}=`));
  return t ? decodeURIComponent(t.split("=")[1]) : null;
}, re = () => {
  const e = se("s_vnum");
  if (!e) return null;
  const t = e.match(/&vn=(\d+)/);
  if (!t) return null;
  const n = parseInt(t[1], 10);
  return Number.isNaN(n) ? null : n;
}, ae = () => {
  const e = {
    TIMESTAMP: "customerLastSessionTimestamp",
    STATUS: "customerNewOrRepeat",
    VISITS: "customerVisitCount"
  }, t = 30 * 60 * 1e3, n = localStorage.getItem(e.TIMESTAMP);
  let i = parseInt(localStorage.getItem(e.VISITS) || "1", 10);
  const o = re();
  o !== null && o > i && (i = o);
  let r = "New", s = i;
  return n && (Date.now() - parseInt(n, 10) > t && (s += 1), s > 1 && (r = "Repeat")), localStorage.setItem(e.STATUS, r), localStorage.setItem(e.VISITS, s.toString()), localStorage.setItem(e.TIMESTAMP, Date.now().toString()), {
    customerNewOrRepeat: r,
    customerVisitCount: s.toString()
  };
};
function z() {
  var e;
  return typeof (window == null ? void 0 : window.alloy) == "function" && typeof ((e = window == null ? void 0 : window.rei_metrics_info) == null ? void 0 : e.alloy) == "object";
}
const ce = (e) => {
  var t, n, i, o, r, s;
  return !((n = (t = window.metrics) == null ? void 0 : t.errors) != null && n.length) && ((o = (i = window.metrics) == null ? void 0 : i.config) == null ? void 0 : o.noview) || !((s = (r = window.metrics) == null ? void 0 : r.config) != null && s.noview) && e();
}, le = (e) => {
  const t = { siteId: "", templateType: "" };
  if (!e) return t;
  const n = e.includes(A);
  if (!(!!e && !!n)) return t;
  const o = e.split(A), [r] = o;
  let [, s] = o;
  if (s.includes(N)) {
    const l = s.split(
      N
    );
    [s] = l;
    const [, u] = l;
    t.pageSection = u;
  }
  return t.siteId = r, t.templateType = s, t;
}, ue = (e) => {
  if (typeof e != "object") return "";
  const { siteId: t, templateType: n, pageSection: i = null } = e;
  if (!t || !n) return "";
  let o = `${t}:${n}`;
  return i && (o += `${N}${i}`), o;
}, de = (e) => Object.fromEntries(
  Object.entries(e).filter((t) => t[1] !== null && t[1] !== "")
), b = async (e) => {
  if (e) {
    const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
    return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
  }
  return null;
}, me = async () => {
  var e, t, n, i, o, r, s;
  if (window.reiSession) {
    const a = await B(3e3, Q()).catch((f) => (c({
      level: "warn",
      message: `Could not get user from session: ${f}`
    }), !1));
    if (!a) return {};
    const l = (n = (t = (e = a == null ? void 0 : a.contact) == null ? void 0 : e.email) == null ? void 0 : t.trim()) != null ? n : null, u = await b((i = l == null ? void 0 : l.toLowerCase()) != null ? i : null), p = await b((o = l == null ? void 0 : l.toUpperCase()) != null ? o : null);
    return {
      isLoggedIn: a != null && a.isLoggedIn ? "logged in" : "not logged in",
      onlineAccountNumber: a != null && a.isLoggedIn ? a.accountId : null,
      customerMemberStatus: a != null && a.membership ? "member" : "non-member",
      memberNumber: (s = (r = a == null ? void 0 : a.membership) == null ? void 0 : r.memberNumber) != null ? s : null,
      preferredStore: a == null ? void 0 : a.preferredStore,
      hasGPC: K(),
      hashedEmail: u,
      hashedUpperCaseEmail: p
    };
  }
  return {};
}, R = async (e, t) => {
  var S;
  const n = q.getWindowSize(), i = t(), o = await me(), r = H(), {
    siteId: s,
    pageName: a,
    pageSection: l,
    products: u,
    productSkus: p,
    productStyles: f,
    templateType: w
  } = e || {}, {
    siteId: D,
    pageName: k,
    pageSection: I,
    productSkus: y,
    productStyles: E,
    templateType: v
  } = (S = window == null ? void 0 : window.utag_data) != null ? S : {};
  let d = {
    currentBreakpoint: n,
    siteId: s || D || null,
    pageName: a || k || null,
    pageSection: l || I || null,
    products: u ? ne(u) : null,
    productSkus: p || y || null,
    productStyles: f || E || null,
    templateType: w || v || null,
    ...o,
    ...r
  };
  if (d.pageName) {
    const h = le(d.pageName);
    d.siteId = d.siteId || h.siteId || null, d.pageSection = d.pageSection || h.pageSection || null, d.templateType = d.templateType || h.templateType || null;
  } else
    d.pageName = ue(d);
  if (d.products && !d.productStyles && (d.productStyles = ie(
    d.products
  )), d.fpid = oe(), z()) {
    const { customerNewOrRepeat: h, customerVisitCount: O } = ae();
    d.customerNewOrRepeat = h, d.customerVisitCount = O;
  }
  return d = de(d), window.utag_data = {
    ...window.utag_data,
    ...i,
    ...e,
    ...d
  }, window.utag_data;
}, pe = (e) => {
  let t = "";
  return typeof e == "object" ? t = e.linkName || "" : typeof e == "string" && (t = e), t;
}, L = (e) => {
  var a;
  let t = "";
  const n = pe(e);
  let i = e.siteId || ((a = window == null ? void 0 : window.utag_data) == null ? void 0 : a.siteId) || "", o = A;
  const r = /^[^:]+:.*/, s = /^ct_.*/;
  return e.patternFunction && typeof e.patternFunction == "function" ? t = e.patternFunction(e) : n.match(s) ? i = "" : !n.match(r) && !n.match(s) && (typeof e.contentSection != "undefined" && (i = e.contentSection, o = N, typeof e.verticalPosition != "undefined" && (i = `ct_${e.verticalPosition}_${i}`)), t = i && i.length > 0 ? `${i}${o}` : ""), t += n, t;
}, fe = (e) => {
  var i;
  let t = {};
  e !== null && typeof e == "object" ? (t = e, t.linkName = L(t)) : e !== null && typeof e == "string" ? t.linkName = L({ linkName: e }) : c({
    level: "error",
    message: "No valid linkName provided"
  });
  const { pageName: n } = (i = window == null ? void 0 : window.utag_data) != null ? i : {};
  return t.pageName = t.pageName || n, t;
}, j = (e, t) => {
  const n = Object.keys(t != null ? t : {}), i = (r) => n.includes(r) ? !0 : (c({
    level: "error",
    message: `Data Layer incomplete: ${r} is a required field.`
  }), !1);
  return X[e].every(i);
}, F = (e) => j("view", e) || !1, ge = (e) => j("link", e) || !1, x = () => window.utag ? window.utag_data ? !0 : (c({
  level: "error",
  message: "Data layer not defined"
}), !1) : (c({
  level: "error",
  message: "Tealium not loaded"
}), !1);
function U() {
  return new M("page-meta-data").get();
}
const we = (e = "") => {
  if (e)
    return e;
  const { pathname: t } = document.location, n = Object.keys(C).find((i) => t.startsWith(i, 1));
  return n ? C[n] : T.profile;
}, ye = () => window.navigator.userAgent.includes("LR_REI_PERF_") || window._DATADOG_SYNTHETICS_BROWSER !== void 0 || P.get("datadog-synthetics-public-id") !== void 0 || P.get("datadog-synthetics-result-id") !== void 0, ve = () => new M("page-meta-data").get() || {}, Se = (e = "") => {
  let t;
  if (e && (e === "qa" || e === "prod"))
    t = e;
  else {
    const n = document.location.hostname.split(".")[0];
    _[n] ? t = _[n] : t = T.env;
  }
  return t;
}, he = (e) => {
  const t = e;
  t && Object.keys(T).forEach((n) => {
    const i = n;
    n in t && (typeof t[i] == "boolean" || t[i].length > 0) && (window.metrics.config[n] = t[i], delete t[i]);
  }), window.metrics.config.env = Se(window.metrics.config.env), window.metrics.config.profile = we(window.metrics.config.profile), window.metrics.config = Object.assign(T, window.metrics.config), window.utag_cfg_ovrd = {
    noview: window.metrics.config.noview
  };
}, ke = async (...e) => {
  var t, n;
  Object.assign((t = window == null ? void 0 : window.utag_data) != null ? t : {}, ...e), !window.metrics.viewQueue.length && await R((n = window == null ? void 0 : window.utag_data) != null ? n : {}, U);
}, Ie = (e) => {
  try {
    (function(t, n, i, o, r, s) {
      i = "https://tags.tiqcdn.com/utag/rei/" + n + "/" + t + "/utag.js", o = document, r = "script", s = o.createElement(r), s.onload = e, s.src = i, s.type = "text/java" + r, s.async = !0, i = o.getElementsByTagName(r)[0], i.parentNode.insertBefore(s, i);
    })(window.metrics.config.env, window.metrics.config.profile);
  } catch (t) {
    return c({
      level: "error",
      message: `Error adding Tealium script: ${t}`
    }), !1;
  }
  return !0;
}, Ee = () => {
  window.metrics.linkQueue && window.metrics.linkQueue.length > 0 && window.metrics.linkQueue.forEach((t) => {
    const {
      eventType: n,
      processed: i,
      callback: o,
      data: r
    } = t;
    ["link", "click", "event"].includes(n) && !i && (window.metrics.link(r, o, n), t.processed = !0);
  });
}, Ne = () => {
  window.metrics.viewQueue && window.metrics.viewQueue.length > 0 && window.metrics.viewQueue.forEach((t) => {
    const {
      eventType: n,
      processed: i,
      data: o,
      callback: r
    } = t;
    n === "view" && !i && (window.metrics.view(o, r), t.processed = !0);
  });
}, Te = async (e, t) => {
  const n = e, i = window.utag_data || {}, o = ve();
  window.utag_data = {}, await ke(o, i, n);
  const r = () => {
    c({
      level: "info",
      message: "Initialized."
    }), window.metrics.config.noview === !1 && (c({
      event: "view",
      data: (window == null ? void 0 : window.utag_data) || {}
    }), window.metrics.pageViewSent = !0), Ne(), typeof t == "function" && t();
  };
  !ye() && ce(() => F(window.utag_data)) ? (Ie(r), window.metrics.config.autoClickListeners && window.metrics.addClickListenersFromSelector(), window.metrics.listenerAlgonomyData()) : c({
    level: "info",
    message: "Skipped injecting Tealium script. If not expected confirm required data is provided."
  }), window.metrics.initialized = !0, window.metrics.initializing = !1;
}, De = (e) => {
  var t;
  return (e == null ? void 0 : e.dataset) && ((t = e == null ? void 0 : e.dataset) == null ? void 0 : t.analyticsId);
}, V = (e) => {
  const t = e == null ? void 0 : e.closest("[data-location-index]");
  return t || (e == null ? void 0 : e.closest("[data-location-name]"));
}, g = (e, t) => (e == null ? void 0 : e.getAttribute(`data-analytics-${t}`)) || void 0, Ae = (...e) => {
  const t = {};
  return e.forEach((n) => {
    t.verticalPosition || (t.verticalPosition = g(n, "vertical")), t.horizontalPosition || (t.horizontalPosition = g(n, "horizontal")), t.zoneName || (t.zoneName = g(n, "zone")), t.componentName || (t.componentName = g(n, "component"));
  }), t;
}, Pe = (e) => {
  var o, r;
  const t = [];
  let n = "", i = V(e.parentNode);
  for (; i; )
    (o = i.dataset) != null && o.locationName && t.unshift(i.dataset.locationName), (r = i.dataset) != null && r.locationIndex && !n && (n = i.dataset.locationIndex), i = V(i.parentNode);
  return {
    locationNames: t.join("_"),
    locationIndex: n
  };
}, _e = (e) => {
  const t = e.querySelector("img");
  return t ? t.getAttribute("alt") : "";
}, Ce = (e) => `${e.dataset.analyticsId || e.textContent || _e(e)}`.trim() || "undefined", $e = (e) => {
  const t = e.closest("a, button");
  return t || !1;
}, be = (e) => {
  var I;
  const t = e.target;
  if (t.closest(`
  [data-analytics-config="exclude"] > a,
  [data-analytics-config="exclude"] > button,
  [data-analytics-config="exclude-all"] a,
  [data-analytics-config="exclude-all"] button`)) return;
  const i = $e(t);
  if (!i) return;
  const o = i.closest("[data-analytics-location]"), r = i.closest("[data-location-name]"), s = {
    linkName: (I = De(i)) != null ? I : Ce(i)
  };
  if (o) {
    const y = g(o, "vertical"), E = g(o, "horizontal"), v = g(o, "zone"), d = g(o, "component"), S = g(o, "location");
    if (S && (s.linkName = S), !y || !v) {
      window.metrics.errors.push({ message: "data-analytics-location required a vertical and zone name value" });
      return;
    }
    y && (s.verticalPosition = y), E && (s.horizontalPosition = E), v && (s.zoneName = v), d && (s.componentName = d), i.tagName === "A" && i.href && (s.destinationUrl = i.href), window.metrics.link(s, e);
    return;
  }
  const {
    verticalPosition: a,
    horizontalPosition: l,
    zoneName: u,
    componentName: p
  } = Ae(i, r, t);
  a && (s.verticalPosition = a), l && (s.horizontalPosition = l), u && (s.zoneName = u), p && (s.componentName = p);
  const { locationNames: f, locationIndex: w } = Pe(t), [D, k] = f.split("_");
  f && D === "ct" && Number.isInteger(parseInt(k, 10)) && (s.linkName = `${f}_${s.linkName}`, s.verticalPosition = k), s.linkName && t.tagName === "A" && t.href && (s.destinationUrl = t.href), w && Number.isInteger(parseInt(w, 10)) && (s.horizontalPosition = w), window.metrics.link(s, e);
}, Le = {
  data() {
    return {
      defaultAnalyticsViewData: {
        siteId: "rei"
        // optional override in the component with the analyticsViewData() computed value
      }
    };
  },
  computed: {
    analyticsMap() {
      if (!this.renderingMap) return {};
      let e = 1;
      return Object.keys(this.renderingMap).reduce(
        (t, n) => (this.renderingMap[n] && (t[n] = `ct_${e}_${n}`, e += 1), t),
        {}
      );
    }
  },
  mounted() {
    window && window.metrics && (window.metrics.addClickListenersFromSelector(), window.metrics.view(
      {
        ...this.defaultAnalyticsViewData,
        ...this.analyticsViewData
      }
    ));
  }
};
function xe() {
  return new Promise((e) => {
    setTimeout(e, 0);
  });
}
const Ve = (e) => {
  const t = ["message", "placementName", "strategy"];
  return e.map((n, i) => {
    const o = {
      rrPlacementIndex: i.toString()
    };
    return Object.keys(n).forEach((r) => {
      if (t.includes(r) && n[r] !== void 0) {
        const s = `rr${r.charAt(0).toUpperCase()}${r.slice(1)}`;
        o[s] = n[r];
      } else
        o[r] = n[r];
    }), o;
  });
}, Me = () => document.cookie.split("; ").map((t) => t.split("=").map((n) => n.trim())).filter(([t]) => t.startsWith("kndctr_")).map(([, t]) => {
  var n;
  try {
    const i = decodeURIComponent(t), o = JSON.parse(i);
    return (n = o == null ? void 0 : o.identity) == null ? void 0 : n.ECID;
  } catch {
    return;
  }
}).find(Boolean), ze = () => document.cookie.split("; ").map((t) => t.split("=").map((n) => n.trim())).filter(([t]) => t.startsWith("AMCV_")).map(([, t]) => {
  const i = decodeURIComponent(t).match(/\|MCMID\|([^|]+)\|/);
  return i ? i[1] : void 0;
}).find(Boolean), Re = () => Me() || ze(), m = {
  version: "4.13.1",
  errors: [],
  config: {},
  eventLog: [],
  viewQueue: [],
  linkQueue: [],
  pageViewSent: !1,
  pageViewSending: !1,
  initialized: !1,
  initializing: !1,
  mixins: { analyticsMixin: Le },
  view: async (e, t) => {
    var i, o, r;
    const n = (s = !0) => {
      var a;
      s && c({
        eventType: "view",
        data: e,
        utagData: (a = window == null ? void 0 : window.utag_data) != null ? a : {}
      }), m.pageViewSending = !1, m.pageViewSent = !0, typeof t == "function" && t(), Ee();
    };
    if (m.pageViewSending = !0, !window.utag || !m.initialized || m.initializing)
      m.viewQueue.push({
        eventType: "view",
        data: e,
        utagData: (i = window == null ? void 0 : window.utag_data) != null ? i : {},
        callback: t
      });
    else
      try {
        await R(e, U), x() && F(window.utag_data) && ((r = (o = window.utag).view) == null || r.call(o, window.utag_data, n));
      } catch (s) {
        c({
          level: "error",
          eventType: "view",
          message: `view event error: ${s}`
        }), n(!1);
      }
  },
  link: async (e, t, n = "link") => {
    var a, l;
    let i;
    typeof e == "string" ? i = e : i = { ...e };
    const o = fe(e), r = {
      eventType: n,
      data: i,
      utagData: { ...window.utag_data, ...o }
    }, s = (u = !0) => {
      u && c(r), typeof t == "function" ? t() : typeof t == "string" && (window.location.href = t);
    };
    if (!m.pageViewSent || m.pageViewSending)
      m.linkQueue.push({
        ...r,
        callback: t
      });
    else
      try {
        x() && ge(o) && (await xe(), typeof window.s != "undefined" && !window.s.useBeacon && (window.s.useBeacon = !0), (l = (a = window == null ? void 0 : window.utag) == null ? void 0 : a.link) == null || l.call(a, o, s));
      } catch (u) {
        c({
          level: "error",
          eventType: "link",
          message: `link event error: ${u}`
        }), s(!1);
      }
  },
  /**
   * Legacy click method for backwards compatability, remove after @rei-metrics 3.0 is fully adopted
   * @deprecated Use {@link Metrics.link} instead
   * @param data
   * @param element
   * @param cb
   */
  click: (e, t, n) => {
    if (!e) {
      c({
        level: "error",
        eventType: "click",
        message: "click event data not provided"
      });
      return;
    }
    n && typeof n == "function" ? m.link(e, n, "click") : t && t.href ? m.link(e, t.href, "click") : m.link(e, void 0, "click");
  },
  event: (e, t) => {
    try {
      m.link(e, t, "event");
    } catch (n) {
      c({
        level: "error",
        eventType: "event",
        message: `event error: ${n}`
      }), typeof t == "function" && t();
    }
  },
  /**
   * Retrieves the Experience Cloud ID (ECID) using Alloy if available,
   * otherwise falls back to the Visitor ID or cookies.
   *
   * @returns Promise that resolves to the ECID string or undefined if not found
   */
  async getVisitorId() {
    var t, n, i;
    if (z())
      try {
        const o = await ((t = window == null ? void 0 : window.alloy) == null ? void 0 : t.call(window, "getIdentity")), r = (n = o == null ? void 0 : o.identity) == null ? void 0 : n.ECID;
        if (r) return r;
      } catch (o) {
        c({
          level: "error",
          message: `Error retrieving ECID from Alloy: ${o}`
        });
      }
    else if ((i = window.visitor) != null && i.getMarketingCloudVisitorID)
      try {
        const o = window.visitor.getMarketingCloudVisitorID();
        if (o) return o;
      } catch (o) {
        c({
          level: "error",
          message: `Error retrieving Visitor ID: ${o}`
        });
      }
    const e = Re();
    if (e)
      return e;
    c({
      level: "error",
      message: "ECID not found via Alloy, Visitor ID, or cookies."
    });
  },
  /**
   * Applies click listeners to all <a> and <button> child elements within a given selector
   * (default selector is #app).
   *
   * @param wrapSelector optional selector used to limit where listeners should be added
   * on the pages
   */
  addClickListenersFromSelector: (e = "#app") => {
    e === "#app" && document.querySelectorAll("#app").length > 1 && c({
      level: "error",
      message: 'Multiple elements found with ID "app", and element IDs must be unique! Analytics reporting will be inaccurate.'
    });
    const t = document.querySelectorAll(`${e} > *`);
    Array.from(t).forEach((i) => {
      i.addEventListener("click", be);
    });
  },
  init: async (e, t) => {
    if (m.initialized || m.initializing) {
      c({
        level: "info",
        message: "Already initialized, skipping duplicate init"
      });
      return;
    }
    const n = { ...e };
    he(n), (!e || Object.keys(e).length === 0) && c({
      level: "warn",
      message: "You should probably add some configuration"
    }), c({
      level: "info",
      message: "Page has loaded, initializing now."
    }), m.initializing = !0, await Te(e, t);
  },
  listenerAlgonomyData: () => {
    document.addEventListener("rr-json-data-loaded", (e) => {
      const t = e, n = t.detail, i = JSON.parse(n);
      Ve(i == null ? void 0 : i.placements).forEach((r) => {
        r.linkName = t.type, m.event(r);
      });
    });
  }
};
typeof window != "undefined" && (window.metrics = m);
export {
  m as default
};
